import * as THREE from 'three';
import { J3PanelBase } from './J3PanelBase';
import {SoundData} from './J3TypeList';

export class J3SoundPanel extends J3PanelBase{    
     //PaneleBase.state でサウンドオン・オフを判断
     listener: THREE.AudioListener;
     audio: THREE.Audio | null = null;
     volume:number = 1.0;
     currentKey: string;
     delay: number = 0.0;


    constructor(debugLvl:number = 0, public name:string='', enable:boolean=true, autoStart:boolean = false, public dir = 'sounds', public soundData:SoundData[], public index:number=0, public volumeMaster:number = 1.0, btnContainerID:string = 'header_ul', onOffButtonID:string = 'icn_sound', iconOnFile:string, iconOffFile:string){
        super();

        if (enable) {
            const btnContainer = document.querySelector('#' + btnContainerID) as HTMLElement;
            if (btnContainer) {
                /*
                //ボタンDOM構造
                <div class="header_nav">
                    <ul id="header_ul" class="list-inline hover"> //既存要素
                        <li id="icn_sound">
                            //ここにオンオフボタンを作成
                        </li>
                    </ul>
                </div>
                */
                const li = document.createElement('li');
                li.setAttribute("id", onOffButtonID);   //li要素にIDを追加
                this.MakeOnOffButtonDOM(li, iconOnFile, iconOffFile);
                btnContainer.appendChild(li);
                this.SetButtons(onOffButtonID);

            }
            this.SetSound(index, autoStart);

            this.addEventListener("change", (evt) => { this.EventReceiver(evt) });
        }

    }


    SetSound(index:number = 0, autoStart:boolean=false) {
        // create an AudioListener and add it to the camera
        //const renderer:THREE.WebGLRenderer = new THREE.WebGLRenderer();   //Audioだけ使うので描画不要
        //const scene:THREE.Scene = new THREE.Scene();
        this.listener = new THREE.AudioListener();
        // Three.jsのサンプルではAudioListenerをカメラまたは３Dオブジェクトにaddしているが、音声再生のみなら不要
        //AudioListenerのためにダミーカメラを作成
        //const camera:THREE.PerspectiveCamera = new THREE.PerspectiveCamera(45, 640/480, 1, 10000);
        //camera.position.set(0,0,0);       
        //camera.add( this.listener );
        //BGM
        const sound = new THREE.Audio(this.listener);
        //scene.add(sound);
        // load a sound and set it as the Audio object's buffer
        const audioLoader = new THREE.AudioLoader();
        const soundElem = this.soundData[index];
        const volume = this.volumeMaster * soundElem.volume;
        audioLoader.load(this.dir + soundElem.fileName, function (buffer) {
            sound.setBuffer(buffer);
            sound.setLoop(true);
            sound.setVolume(volume);
            //sound.play();
        });
        this.audio = sound;
    }

    EventReceiver(evt){
        this.state = evt.detail.state;
        if(evt.detail.state == true){
            console.log('Sound Play');
            this.Play();
        }else{
            console.log('Sound Pause');
            this.Pause();
        }
    }

    Play() {
        if (this.audio) {
            if (!this.audio.isPlaying) {
                this.audio.play(this.delay);
                let event = new CustomEvent("sound", { detail: { state: true } });
                this.dispatchEvent(event);
                if (this.onOffButton) this.onOffButton.LookOn();
            }
        }
    }
    Stop() {
        if (this.audio) {
            if (this.audio.isPlaying) {
                this.audio.stop();
                let event = new CustomEvent("sound", { detail: { state: false } });
                this.dispatchEvent(event);
                if (this.onOffButton) this.onOffButton.LookOff();
            }
        }
    }
    Pause() {
        if (this.audio) {
            if (this.audio.isPlaying) {
                this.audio.pause();
                let event = new CustomEvent("sound", { detail: { state: false } });
                this.dispatchEvent(event);
                if (this.onOffButton) this.onOffButton.LookOff();
            }
        }
    }
    Resume() {
        if (this.audio) {
            if (!this.audio.isPlaying) {
                this.audio.play();
                let event = new CustomEvent("sound", { detail: { state: true } });
                this.dispatchEvent(event);
                if (this.onOffButton) this.onOffButton.LookOn();
            }
        }
    }
    SetVolume(volume: number = 1.0) {
        this.audio.setVolume(this.volumeMaster * volume);
    }
}